import { axiosGet, axiosPost } from "../../react_axios/Axios"
import { getCartDetailsUrl, generateUniqueNoUrl, GENERATE_UNIQUE_NO, GET_CART_DETAILS, paymentUrl, PAYMENT_ACTION_TYPE, saveForLaterUrl, addToCartUrl, ADD_TO_CART, SAVE_FOR_LATER, removeOrderUrl, REMOVE_ORDER, createOrderUrl, CREATE_PAYMENT_ORDER, headers } from "../../utils/constants"
import moment from 'moment';


export const cart_details_action = (userID, orderID) => async (dispatch) => {
    try {
        const mapdata = {
            userID: parseInt(userID),
            OrderID: orderID,
        }
        console.log("data----------", mapdata)
        const res = await axiosGet(getCartDetailsUrl, mapdata, headers);

        dispatch({
            type: GET_CART_DETAILS,
            payload: res,
        });
        console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const save_for_later_action = (userID, orderID) => async (dispatch) => {
    try {
        const mapdata = {
            userID: userID,
            OrderID: orderID,
        }
        console.log("data----------", mapdata)
        const res = await axiosGet(saveForLaterUrl, mapdata, headers);

        dispatch({
            type: SAVE_FOR_LATER,
            payload: res,
        });
        console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const remove_order_action = (userID, orderID) => async (dispatch) => {
    try {
        const mapdata = {
            userID: userID,
            OrderID: orderID,
        }
        console.log("data----------", mapdata)
        const res = await axiosGet(removeOrderUrl, mapdata, headers);

        dispatch({
            type: REMOVE_ORDER,
            payload: res,
        });
        console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const add_to_cart_action = (userID, orderID) => async (dispatch) => {
    try {
        const mapdata = {
            userID: userID,
            OrderID: orderID,
        }
        console.log("data----------", mapdata)
        const res = await axiosGet(addToCartUrl, mapdata, headers);

        dispatch({
            type: ADD_TO_CART,
            payload: res,
        });
        console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const payment_action = (payload) => async (dispatch) => {
    try {
        console.log("data----------", payload)
        const res = await axiosPost(paymentUrl, payload, headers);

        dispatch({
            type: PAYMENT_ACTION_TYPE,
            payload: res,
        });
        console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const generate_unique_no_action = (userID, finalUniqueNo, orderIDList) => async (dispatch) => {
    try {
        const mapData = {
            UserID: userID == '' || userID == null ? 0 : userID,
            UniqueNo: finalUniqueNo,
            orderIDList: orderIDList
        }
        console.log("data----------", mapData,mapData.UniqueNo)
        const res = await axiosPost(generateUniqueNoUrl, mapData, headers);

        dispatch({
            type: GENERATE_UNIQUE_NO,
            payload: res,
        });
        console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

//razor pay payment// UAT pe check kr
export const create_payment_order_action = (ToPay, finalCurrency, orderIDList, Is_25percent, IsAdditionalServices, RazorpayOrderStatus) => async (dispatch) => {
    try {
        const mapData = {
            UserID: parseInt(sessionStorage.getItem('userId')),
            amount: parseInt(ToPay),
            currency: finalCurrency,
            orderIDList: orderIDList,
            Is_25percent: Is_25percent,
            IsAdditionalServices: IsAdditionalServices,
            RazorpayOrderStatus: RazorpayOrderStatus,
            // paymentType: paymentType
        }
        console.log("data----------", mapData)
        const res = await axiosPost(createOrderUrl, mapData);

        dispatch({
            type: CREATE_PAYMENT_ORDER,
            payload: res,
        });
        console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};